import React from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import PageLayout from './PageLayout';

const IframePage = ({ src }) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <PageLayout
      title="Documento"
      subtitle="Conteudo externo"
      onBack={handleHomeClick}
      contentMaxW="1280px"
      accent="#93C8E6"
      background="#EEF3F7"
      watermark="/maconaria.png"
    >
      <Box px={{ base: 2, md: 4 }} py={{ base: 2, md: 4 }}>
        <Box
          bg="white"
          borderRadius="26px"
          boxShadow="0 16px 40px rgba(0,0,0,0.25)"
          overflow="hidden"
          minH="70vh"
          border="1px solid rgba(15,23,42,0.08)"
        >
          <Box
            p={{ base: 3, md: 5 }}
            bg="white"
            height="100%"
          >
            <Box
              as="iframe"
              src={src}
              width="100%"
              height="100%"
              border="none"
              minH="70vh"
              style={{ borderRadius: '20px' }}
            />
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default IframePage;
